import React, { useState, useEffect } from 'react'
import GMap from '..'

const fn = () => {}

const DrawingManagerMap = ({
  mapOptions = {},
  drawingManagerOptions = {},
  initialOverlays = [],
  overlays = [],
  onOverlayComplete = fn,
  setDrawingManager = fn,
  initOverlay = fn,
  onMapInit = fn,
}) => {
  const [google, setScript] = useState(null)
  const [map, setMap] = useState(null)

  useEffect(() => {
    if (!google || !map) return
    const unsubscribe = initMap()
    return () => {
      unsubscribe()
      setDrawingManager(null)
    }
  }, [google, map, initialOverlays])

  useEffect(() => {
    if (!google || !map || !Array.isArray(initialOverlays)) return
    addMissingOverlays()
  }, [map, initialOverlays])

  const initMap = () => {
    const drawingManager = new google.maps.drawing.DrawingManager({
      drawingControl: false,
      circleOptions: {
        editable: true,
      },
      markerOptions: {
        editable: true,
      },
      polygonOptions: {
        editable: true,
      },
      polylineOptions: {
        editable: true,
      },
      rectangleOptions: {
        editable: true,
      },
      ...drawingManagerOptions,
    })
    drawingManager.setMap(map)
    onMapInit(map, google)
    setDrawingManager(drawingManager)

    const listener = google.maps.event.addListener(
      drawingManager,
      'overlaycomplete',
      onOverlayComplete,
    )

    return () => {
      google.maps.event.removeListener(listener)
      drawingManager.setMap(null)
      onMapInit(null)
    }
  }

  const addMissingOverlays = () => {
    const existingKeys = overlays.map(({ key }) => key)
    const newInitialOverlays = initialOverlays.filter(
      ({ mapPolygonProps }) => !existingKeys.includes(mapPolygonProps.key),
    )
    setInitialOverlays(newInitialOverlays, map)
  }

  const setInitialOverlays = (initialOverlays, map) => {
    if (map && initialOverlays && initialOverlays.length > 0) {
      initialOverlays.forEach(({ id, paths, color, mapPolygonProps, isPostcode = false }) => {
        const overlay = new google.maps.Polygon({
          customId: id,
          key: id,
          clickable: true,
          map: map,
          paths,
          strokeColor: color,
          fillColor: color,
          canBeDeleted: true,
          strokeWeight: 2,
          isPostcode,
          ...mapPolygonProps,
        })

        initOverlay(overlay)
      })
    }
  }

  const areCoordinatesProvided =
    mapOptions.center && mapOptions.center.lat && mapOptions.center.lng
  const zoomLevel = areCoordinatesProvided ? 12 : 2
  const defaultCoordinates = {
    lat: 0,
    lng: 0,
  }
  const cityCoordinates = areCoordinatesProvided
    ? mapOptions.center
    : defaultCoordinates

  return (
    <GMap
      onInit={(map, google) => {
        setMap(map)
        setScript(google)
      }}
      mapSettings={{
        zoom: zoomLevel,
        scaleControl: true,
        mapTypeControlOptions: {
          style: 1, // HORIZONTAL_BAR
          position: 3, // TOP_RIGHT
        },
        ...mapOptions,
        center: cityCoordinates,
      }}
    />
  )
}

export default DrawingManagerMap



// WEBPACK FOOTER //
// ./src/Components/GMap/DrawingManagerMap/index.jsx